// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"Ellipse_ellipse__Wi_YR"};